import React, { FC } from 'react';
import * as s from '../common.styles';
import { useEmailOptModal } from '../Modal/useEmailOptModal';
import { NotificationModal } from '../Modal/NotificationModal';
import { Toast } from '../../common';
import { useSelfBillTerms } from '../SelfBillTerms/useSelfBillTerms';
import { useStore } from '../../../store/state';
import { VerifyInformation } from '../VerifyInformation/VerifyInformation';

export const SocialContainer: FC = ({ children }) => {
  const { handleResponse, isModalOpen, showToast, setShowToast, toastMessage } =
    useEmailOptModal();

  const [{ userState }] = useStore();
  const { isSelfBillModalOpen, ...rest } = useSelfBillTerms(
    userState.user?.influencer_id ?? '',
    'influencer'
  );

  return (
    <s.MainContentWrapper>
      {children}
      <VerifyInformation
        isMobile={false}
        isOpen={isSelfBillModalOpen}
        {...rest}
      />
      <NotificationModal
        handleResponse={handleResponse}
        isModalOpen={!isSelfBillModalOpen && isModalOpen}
      />
      {showToast && (
        <Toast
          message={toastMessage}
          duration={3000}
          type={'message'}
          onClose={() => setShowToast(false)}
        />
      )}
    </s.MainContentWrapper>
  );
};
